export default "/img/signature-fr.png"